import { InjectionToken } from '@angular/core';
import { MsalAuthConfig } from './msal-auth.config';
import { UserActivityConfig } from './user-activity.config';

export const CONFIG_DEFAULTS: Partial<ConfigSettings> = {
  version: 'unknown',
  appCode: 'WEB_APP',
  userActivityConfig: {
    keepAliveTime: 30,
  },
};

export const APP_CONFIG = new InjectionToken<ConfigSettings>(
  'settings from config.json'
);

/**
 * Construct project config with verified default values
 *
 * @param currentConfig
 */
export function getConfig(
  currentConfig: Partial<ConfigSettings>
): ConfigSettings {
  const config = {
    ...CONFIG_DEFAULTS,
    ...currentConfig,
  } as ConfigSettings;

  return verifyConfigDefaults(config);
}

function verifyConfigDefaults(currentConfig: ConfigSettings): ConfigSettings {
  return {
    ...currentConfig,
    version: currentConfig.version || CONFIG_DEFAULTS.version,
    appCode: CONFIG_DEFAULTS.appCode,
    userActivityConfig: {
      ...currentConfig.userActivityConfig,
      keepAliveTime:
        currentConfig.userActivityConfig?.keepAliveTime > 0
          ? currentConfig.userActivityConfig?.keepAliveTime
          : CONFIG_DEFAULTS.userActivityConfig.keepAliveTime,
    },
  };
}

export class ConfigSettings {
  version: string;
  appCode: string;
  dataApiUrl: string;
  orApiUrl: string;
  analyticsUrl: string;
  orAdminUrl: string;
  orGPTUrl: string;
  production: boolean;
  useOauth: boolean;
  userActivityConfig: UserActivityConfig;
  msalConfig: MsalAuthConfig;
  dataApiMsalScope: string;
  enableAiNews: boolean;
  enableAiInsights: boolean;
  securityApiUrl: string;
  company: string;
  speechServiceEnable: boolean;
  speechRecognitionEnabled: boolean;
  chatbotName: string;
  odBackendApiUrl: string;
}
